export enum ContactUploadStatus {
  Draft = 'draft',
  Submitted = 'submitted',
  Complete = 'complete'
}
